import { useContext } from "react";
import { LayerContext } from "../LayerContext";
import { OsmPoiInfo } from "../../../../types/LayerAdmin/OsmPoiInfo";
import {
  TableColumn,
  TableDataType,
} from "../../../../types/Table/TableColumns";
import SortableTable from "../../../Table/SortableTable";
import { TableAction } from "../../../Table/TableAction";
import { Source } from "../../../../types/LayerAdmin/Source";
import { useOsmPoiService } from "../../../../hooks";

interface ForceImportProps {
  backToImports: () => void;
  refreshImports: () => void;
}

const ForceImport = ({ backToImports, refreshImports }: ForceImportProps) => {
  const value = useContext(LayerContext);
  const { layerInfo } = value!;
  const osmInfo = layerInfo as OsmPoiInfo;
  const osmPoiService = useOsmPoiService();

  const forceImport = async (source: Source) => {
    await osmPoiService
      .Force(source.sourceId)
      .then((_) => {
        backToImports();
      })
      .catch(() => {});
  };

  const deferImport = async (source: Source) => {
    await osmPoiService.
    Defer(source.sourceId).then((_) => {
      refreshImports();
    })
    .catch(() => {});
  }

  const columns = [
    { displayName: "Source", field: "displayName", sortable: true },
    {
      displayName: "Est time.",
      field: "estTime",
      sortable: true,
    },
    {
      displayName: "Last import",
      field: "lastImport",
      dataType: TableDataType.DATE,
      dateFormat: "dd/MM/yyyy",
      sortable: true,
    },
    {
      displayName: "Last Deferred",
      field: "lastDeferred",
      dataType: TableDataType.DATE,
      dateFormat: "dd/MM/yyyy",
      sortable: true,
    }
    ,
    { displayName: "Time zone", field: "timeZone" },
  ] as TableColumn[];

  const actions = [
    { onClick: forceImport, show: true, content: "Queue" },
    {onClick: deferImport, show: true, content: "Defer" }
  ] as TableAction[];

  return (
    <SortableTable
      actions={actions}
      columns={columns}
      data={osmInfo.latestSources}
    />
  );
};

export default ForceImport;
